import { ChevronsDownUp, ChevronsUpDown } from "lucide-react";

type Props = {
  allOpen: boolean;
  onSetAll: (open: boolean) => void;
};

export function GroupsToggle({ allOpen, onSetAll }: Props) {
  const Icon = allOpen ? ChevronsDownUp : ChevronsUpDown;
  return (
    <div className="flex justify-end border-b border-slate-200 px-3 py-1.5 dark:border-slate-800">
      <button
        type="button"
        onClick={() => onSetAll(!allOpen)}
        className="inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-xs font-medium text-slate-600 hover:bg-slate-100 hover:text-slate-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-100"
      >
        <Icon aria-hidden className="h-3.5 w-3.5" />
        {allOpen ? "Close all" : "Open all"}
      </button>
    </div>
  );
}
